import PropTypes from 'prop-types';
import classnames from 'classnames';

const ArticleHeader = ({
  featured = false, date, textColor, category
}) => (
  <div className={classnames('header', textColor)}>
    {featured && <i className="fa fa-star float-start" aria-hidden="true"/>}
    <span className="float-end">
      {category.name.toLowerCase() !== 'about ignite' && category.name.toLowerCase() !== 'how to earn' && date}
    </span>
  </div>
);

ArticleHeader.propTypes = {
  featured: PropTypes.bool,
  date: PropTypes.string,
  textColor: PropTypes.string,
  category: PropTypes.object
};

export default ArticleHeader;

